/** @jsxImportSource react */
import { useState } from 'react'
import { Alert, Box, Button, Link, TextField } from '@mui/material'
import { Link as RouterLink, useSearchParams } from 'react-router-dom'
import { useMutation } from '@tanstack/react-query'
import { authAPI } from '../api/auth'
import { getErrorMessage } from '../utils/apiErrors'
import AuthCard from '../components/common/AuthCard'

/** Asks for a reset link. The answer never says whether the address has an account. */
const ForgotPasswordPage = () => {
  const [searchParams] = useSearchParams()
  const [email, setEmail] = useState(searchParams.get('email') || '')
  const request = useMutation({ mutationFn: () => authAPI.forgotPassword(email.trim()) })

  return (
    <AuthCard subtitle="Reset your password">
      {request.isSuccess ? (
        <Alert severity="success" sx={{ mb: 2 }}>
          If an account uses <strong>{email.trim()}</strong>, we’ve emailed it a link to set a new password. The link works for 30 minutes.
        </Alert>
      ) : (
        <Box component="form" onSubmit={(e) => { e.preventDefault(); request.mutate() }} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          {request.error && <Alert severity="error">{getErrorMessage(request.error)}</Alert>}
          <TextField label="Email" type="email" autoComplete="email" autoFocus required value={email} onChange={(e) => setEmail(e.target.value)} />
          <Button type="submit" variant="contained" disabled={request.isPending}>{request.isPending ? 'Sending…' : 'Email me a reset link'}</Button>
        </Box>
      )}
      <Link component={RouterLink} to="/login" variant="body2" sx={{ display: 'inline-block', mt: 2 }}>Back to sign in</Link>
    </AuthCard>
  )
}

export default ForgotPasswordPage
